export const ALLOWED_TAGS = [
  'p',
  'a',
  'ul',
  'ol',
  'li',
  'b',
  'strong',
  'em',
  'i',
  'u',
  's',
];

export const FORBID_ATTR = ['style', 'class'];
